import { useState } from 'react'
import { useApiClient, UsePlanningsEventsManagerParams } from '@/hooks'
import { downloadApiResponse } from '@/utils'

export const usePlanningsEventsExport = () => {
  const client = useApiClient()

  const [loading, setLoading] = useState(false)

  const doExport = async ({ ...params }: UsePlanningsEventsManagerParams) => {
    const queryParams = new URLSearchParams()

    if (params.project) queryParams.append('project', params.project)
    if (params.client) queryParams.append('client', params.client)
    if (params.project_leader)
      queryParams.append('project_leader', params.project_leader)
    if (params.researchArea)
      queryParams.append('research_area', params.researchArea)
    if (params.researchers)
      queryParams.append('researchers', params.researchers)
    if (params.researchAreaResearchers)
      queryParams.append(
        'research_area__researchers',
        params.researchAreaResearchers
      )
    if (params.uncertaintyReason)
      queryParams.append('reason_of_uncertainty', params.uncertaintyReason)
    if (params.animal) queryParams.append('animal', params.animal)
    if (params.startDate) queryParams.append('date_start', params.startDate)
    if (params.endDate) queryParams.append('date_end', params.endDate)

    setLoading(true)
    try {
      const response = await client.get<Blob>(
        `/plannings/events/manager/export/?${queryParams.toString()}`,
        { responseType: 'blob' }
      )

      downloadApiResponse(response)
    } finally {
      setLoading(false)
    }
  }

  return { doExport, loading }
}
